import CalendarTitle from "./CalendarTitle";

export default CalendarTitle;